import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, CardBody, Label, Form, Alert, Input, FormFeedback } from 'reactstrap';
import logoDark from "../../assets/images/logo-dark.png";
import logoLight from "../../assets/images/logo-dark.png";
import * as Yup from "yup";
import { useFormik } from "formik";
import api from '../../utils/api'; // ✅ استخدم api بدل axios

const Login = () => {
  document.title = "";

  const navigate = useNavigate();
  const [loginError, setLoginError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // مفاتيح إظهار/إخفاء للعناصر المطلوبة (تعطيل = true)
  const uiHidden = {
    loginLogo: true,          // شعار الفورم
    welcomeTitle: true,       // عنوان "أهلا بك .."
    welcomeSubtitle: true,    // السطر الذي تحته
    forgotPassword: true,     // رابط "هل نسيت كلمة المرور؟"
    footer: true              // "جميع الحقوق محفوظة"
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
  email: "",
  password: "",
},
    validationSchema: Yup.object({
      email: Yup.string().required("الرجاء ادخال البريد الإلكتروني"),
      password: Yup.string().required("الرجاء ادخال كلمة المرور"),
    }),
    onSubmit: async (values) => {
      try {
        setIsLoading(true);
        setLoginError(null);

        // ✅ محاولة تسجيل الدخول (Bearer Token - لا حاجة لـ CSRF cookie)
        const response = await api.post("/login", {
          email: values.email,
          password: values.password
        });

        

        // ✅ حفظ بيانات المستخدم
        localStorage.setItem("auth_token", response.data.token || "authenticated");
        localStorage.setItem("authUser", JSON.stringify(response.data));
        localStorage.setItem("user", JSON.stringify(response.data.user || response.data));
        // ✅ تخزين الدور بشكل صريح (احتياطي)
        localStorage.setItem("role", (response.data.user?.role || response.data.role || 'user').toLowerCase());
        
        alert("✅ تم تسجيل الدخول بنجاح");
        navigate("/dashboard");

      } catch (error) {
        
        
        if (error.response) {
          
          
          if (error.response.status === 422) {
            setLoginError("البريد الإلكتروني أو كلمة المرور غير صحيحة");
          } else if (error.response.status === 404) {
            setLoginError("خدمة تسجيل الدخول غير متوفرة");
          } else {
            setLoginError(error.response.data.message || "حدث خطأ في تسجيل الدخول");
          }
        } else {
          setLoginError("لا يمكن الاتصال بالخادم");
        }
      } finally {
        setIsLoading(false);
      }
    }
  });

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <CardBody className="pt-0">
                  {!uiHidden.loginLogo && (
                    <h3 className="text-center mt-5 mb-4">
                      <Link to="/" className="d-block auth-logo">
                        <img src={logoDark} alt="" height="30" className="auth-logo-dark" />
                        <img src={logoLight} alt="" height="30" className="auth-logo-light" />
                      </Link>
                    </h3>
                  )}

                  <div className="p-3">
                    {!uiHidden.welcomeTitle && (
                      <h4 className="text-muted font-size-18 mb-1 text-center">أهلا بك ..</h4>
                    )}
                    {!uiHidden.welcomeSubtitle && (
                      <p className="text-muted text-center">الرجاء تسجيل الدخول للوصول الى لوحة التحكم</p>
                    )}
                    
                    
                    
                    <Form className="form-horizontal mt-4" onSubmit={e => { e.preventDefault(); validation.handleSubmit(); return false; }}>
                      {loginError && <Alert color="danger">{loginError}</Alert>}
                      
                      <div className="mb-3">
                        <Label htmlFor="username">إسم المستخدم</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="أدخل البريد الإلكتروني"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={validation.touched.email && validation.errors.email ? true : false}
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                        ) : null}
                      </div>
                      
                      <div className="mb-3">
                        <Label htmlFor="userpassword">كلمة المرور</Label>
                        <Input
                          name="password"
                          value={validation.values.password || ""}
                          type="password"
                          placeholder="أدخل كلمة المرور"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={validation.touched.password && validation.errors.password ? true : false}
                        />
                        {validation.touched.password && validation.errors.password ? (
                          <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                        ) : null}
                      </div>
                      
                      <Row className="mb-3 mt-4">
                        <div className="col-6">
                          <div className="form-check">
                            <input type="checkbox" className="form-check-input" id="customControlInline" />
                            <label className="form-check-label" htmlFor="customControlInline">تذكرني</label>
                          </div>
                        </div>
                        <div className="col-6 text-end">
                          <button 
                            className="btn btn-primary w-md waves-effect waves-light" 
                            type="submit"
                            disabled={isLoading}
                          >
                            {isLoading ? "جاري تسجيل الدخول..." : "تسجيل الدخول"}
                          </button>
                        </div>
                      </Row>
                      
                      {!uiHidden.forgotPassword && (
                        <Row className="form-group mb-0">
                          <Link to="/forgot-password" className="text-muted">
                            <i className="mdi mdi-lock"></i> هل نسيت كلمة المرور؟
                          </Link>
                        </Row>
                      )}
                    </Form>
                  </div>
                </CardBody>
              </Card>

              {!uiHidden.footer && (
                <div className="mt-5 text-center">
                  © {new Date().getFullYear()}
                </div>
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Login;